import React from 'react';
import { ConfirmDialog } from '@/components/dialogs/ConfirmDialog';

/**
 * The "Leave without saving?" confirm shown before throwing away unsaved form changes, e.g.
 * when closing a FolioDrawer with a dirty form. Other ConfirmDialog props (title, content,
 * confirmText, …) override the defaults.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose Stays, keeping the changes.
 * @param {() => void} props.onConfirm Leaves, losing the changes.
 */
export const LeaveWithoutSavingDialog = ({ open, onClose, onConfirm, ...props }) => (
	<ConfirmDialog
		openDialog={open}
		handleClose={onClose}
		handleConfirm={onConfirm}
		title='Leave without saving?'
		content='You may have unsaved changes. Are you sure you want to leave?'
		confirmText='Leave'
		{...props}
	/>
);

LeaveWithoutSavingDialog.displayName = 'LeaveWithoutSavingDialog';
